import { useState } from "react";
import apiJurados from "../api/Jurados/api-jurados";
import apiMaestras from "../api/Maestras/api-maestras";

export const useBancoJurado = () => {
  const [jurados, setJurados] = useState([]);
  const [preJurados, setPreJurados] = useState([]);
  const [totalBancoJurados, setTotalbancoJurados] = useState(0);
  const [totalPostulacions, setTotalPostulaciones] = useState(0);
  const [loadingJurados, setLoadingJurados] = useState(false);

  const [filtros, setFiltros] = useState<any>({
    palabra_clave: "",
    area: null,
    categoria: null,
    estado: null,
  });

  const buscarFiltros = async () => {
    setLoadingJurados(true);
    if (filtros.palabra_clave !== "") {
      if (/^\d+$/.test(filtros.palabra_clave)) {
        var filtro = await apiJurados.obetenerJuradoDoc(filtros.palabra_clave);
      } else {
        var filtro = await apiJurados.obetenerJuradoRadicado(filtros.palabra_clave.toUpperCase());
      }

      console.log('filtro', filtro.juries)
    }

    if (filtros.area !== null) {
      filtro = filtro.filter((x: any) => {
        let area = x.areas_conocimientos[0].area_principal;
        if (area === filtros.area) {
          return x;
        }
      });
    }

    if (filtros.categoria !== null) {
      filtro = filtro.filter((x: any) => {
        let areas_conocimiento_id =
          x.areas_conocimientos[0].areas_conocimientos.map((area) => area.id);
        //console.log(areas_conocimiento_id);
        if (areas_conocimiento_id.includes(filtros.categoria)) {
          return x;
        }
      });
    }

    if (filtros.estado !== null) {
      if (filtros.estado === "null") {
        filtro = filtro.filter((x: any) => x.status === "null");
        return;
      }

      filtro = filtro.filter((x: any) => {
        if (x.status === filtros.estado) {
          return x;
        }
      });
    }

    filtro = filtro.juries.sort((a: any, b: any) => {
      const numA = parseInt(a.radicado.split("-")[1], 10); // Convierte la parte numérica a entero
      const numB = parseInt(b.radicado.split("-")[1], 10);

      return numA - numB; // Ordena en orden ascendente
    });

    setTotalbancoJurados(filtro.length)
    setLoadingJurados(false);
    setJurados(filtro);
    setLoadingJurados(false);
  };

  const [categorias, setCategorias] = useState([]);
  const handleAreaChange = async (id_area: any) => {
    let id = id_area.split(".")[0];
    let area = id_area.split(".")[1];
    try {
      const { data } = await apiMaestras.obtenerCategoriasAreas(Number(id));
      setCategorias(data);

      setFiltros({
        ...filtros,
        area: area,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const limpiarFiltros = (tipo: string) => {
    obtenerJurados(tipo);
    setFiltros({
      palabra_clave: "",
      area: null,
      categoria: null,
      estado: null,
    });
  };

  const obtenerJurados = async (tipo?: string) => {
    setLoadingJurados(true);
    try {
      const jurados = await apiJurados.getJurados();

      switch (tipo) {
        case "gestionEvaluador":
          let gestionEvaluador = jurados.filter(
            (x: any) =>
              [
                "Sin verificar",
                "No cumple",
                "Postulado",
                "Aceptó",
                "Aceptado",
              ].includes(x.status)
          );

          let gestion = gestionEvaluador.map(function (jurado: any) {
            if (jurado.status == "Aceptó") {
              jurado.status = "Postulado";
            }
            return jurado;
          });

          setPreJurados(gestion);
          setJurados(gestion);
          break;

        case "bancojurados":
          console.log('jurados =====', jurados)
          let bancoJurados = jurados.filter((x: any) =>
            [
              "Sin verificar",
              "Postulado",
              "Subsanar",
              "Subsanado",
              "Rechazado",
              "Anulado",
              "Aceptado"
            ].includes(x.status)
          );

          bancoJurados.length > 0
            ? setTotalbancoJurados(bancoJurados.length)
            : setTotalbancoJurados(0);
          setPreJurados(bancoJurados);
          setJurados(bancoJurados);
          break;

        case "postulaciones":
          let postulaciones = jurados.filter((x: any) =>
            ["Postulado", "Aceptó", "No aceptó", "No responde"].includes(x.status)
          );

          postulaciones.length > 0
            ? setTotalPostulaciones(postulaciones.length)
            : setTotalPostulaciones(0);
          setPreJurados(postulaciones);
          setJurados(postulaciones);
          break;

        default:
          setPreJurados(jurados);
          setJurados(jurados);
          break;
      }

      setLoadingJurados(false);
    } catch (error) {
      console.log(error);
    }
  };

  return {
    obtenerJurados,
    jurados,
    totalBancoJurados,
    totalPostulacions,
    loadingJurados,
    handleAreaChange,
    categorias,
    setCategorias,
    filtros,
    setFiltros,
    buscarFiltros,
    limpiarFiltros,
  };
};
